import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { CropOverlay } from './crop-overlay';

type Props = {
  src: string;
  className?: string;
};

export function PhotoCardPreview({ src, className }: Props): ReactNode {
  return (
    <div
      className={cn(
        'relative aspect-[9/16] overflow-hidden rounded-lg bg-black',
        className ?? 'w-28'
      )}
    >
      <img
        src={src}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />
      <CropOverlay />
    </div>
  );
}
